module.exports.batchUpdateJobFilterBody = require('./batch-update-job-filter-body');
module.exports.createJobFilterBody = require('./create-job-filter-body');
module.exports.jobFilterDetail = require('./job-filter-detail');
module.exports.jobFilterList = require('./job-filter-list');
module.exports.jobFiltersParams = require('./job-filters-params.json');
module.exports.shareJobFilterBody = require('./share-job-filter-body');
module.exports.updateJobFilterBody = require('./update-job-filter-body');
module.exports.viewJobFiltersQuery = require('./view-job-filters-query');
module.exports.viewJobFiltersUsersRolesQuery = require('./view-job-filters-users-roles-query.json');
